import { render, staticRenderFns } from "./LastEventView.vue?vue&type=template&id=1279e16d&scoped=true"
import script from "./LastEventView.vue?vue&type=script&lang=js"
export * from "./LastEventView.vue?vue&type=script&lang=js"
import style0 from "./LastEventView.vue?vue&type=style&index=0&id=1279e16d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1279e16d",
  null
  
)

export default component.exports